<template>
    <div>
        <div class="my_modal" v-bind:class="{show: (ropeGuardSelection!=null&&ropeGuardSelection.length>0)}" align="center">
            <div class="my_modal-dialog" style="min-width:800px">
                <div class="my_modal-content" style="max-height: calc(100vh - 50px)">
                    <div>
                        <div class="my_modal-header" style="border-bottom:none">
                            <div class="my_fontSize_1Point5 my_fontWeight_600 my_color_00338e ZAfont_family">{{$t('3464')}} {{$t('3533')}}</div>
                            <div>
                                <span @click="closeModal(false)" class="fal fa-times fa-2x"></span>
                            </div>
                        </div>
                        <div class="my_modal-body" style="height:calc(100vw - 160px)">
                            <div style="margin-top: 10px;">
                                <table class="my_table_suspensionMeans ZAfont_family ZAfont_size">
                                    <thead style="height:60px">
                                        <tr style="display:flex; height:100%">
                                            <th style="flex:0 0 10%">ID</th>
                                            <th style="flex:0 0 9%">FUESSE</th>
                                            <th style="flex:0 0 9%">SEILAB</th>
                                            <th style="flex:0 0 9%">EINST</th>
                                            <th style="flex:0 0 9%">TNSCHU</th>
                                            <th style="flex:0 0 9%">TNABDE</th>
                                            <th style="flex:0 0 9%">TNSABD</th>
                                            <th style="flex:0 0 9%">TNABDI</th>
                                            <th style="flex:0 0 9%">TNKLEM</th>
                                            <th style="flex:0 0 9%">TNRUEV</th>
                                            <th style="flex:0 0 9%">TNABSP</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="ropeGuard in ropeGuardSelection" @click="rowClick(ropeGuard, $event)" style="display:flex">
                                            <td style="flex: 0 0 10%; text-align: left">
                                                <span v-if="ropeGuard.id!=null">{{ropeGuard.id}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex: 0 0 9%; text-align: left">
                                                <span v-if="ropeGuard.fuesse!=null&&ropeGuard.fuesse.text!=null">{{ropeGuard.fuesse.useTextKey?$t(ropeGuard.fuesse.textKey):ropeGuard.fuesse.textUI}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex: 0 0 9%; text-align: left ">
                                                <span v-if="ropeGuard.seilab!=null">{{ropeGuard.seilab.useTextKey?$t(ropeGuard.seilab.textKey):ropeGuard.seilab.textUI}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex: 0 0 9%; text-align: left">
                                                <span v-if="ropeGuard.einst!=null">{{ropeGuard.einst.useTextKey?$t(ropeGuard.einst.textKey):ropeGuard.einst.textUI}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex: 0 0 9%; text-align: left">
                                                <span v-if="ropeGuard.tnschu!=null">{{ropeGuard.tnschu}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex: 0 0 9%; text-align: left">
                                                <span v-if="ropeGuard.tnabde!=null">{{ropeGuard.tnabde}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex: 0 0 9%; text-align: left">
                                                <span v-if="ropeGuard.tnsabd!=null">{{ropeGuard.tnsabd}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex: 0 0 9%; text-align: left">
                                                <span v-if="ropeGuard.tnabdi!=null">{{ropeGuard.tnabdi}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex: 0 0 9%; text-align: left">
                                                <span v-if="ropeGuard.tnklem!=null">{{ropeGuard.tnklem}}</span>
                                                <span v-if="ropeGuard.tnklel!=null">{{ropeGuard.tnklel}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex: 0 0 9%; text-align: left">
                                                <span v-if="ropeGuard.tnruev!=null">{{ropeGuard.tnruev}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex: 0 0 9%; text-align: left">
                                                <span v-if="ropeGuard.tnabsp!=null">{{ropeGuard.tnabsp}}</span>
                                                <span v-else>-</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="my_modal-footer" style="min-width:800px;justify-content:flex-end;">
                        <div>
                            <button @click="closeModal(false)" class="btn my_btn_standard" style="margin-right:5px">{{$t('3237')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import router from '../../../router';
    import { configurations } from '../../../store/configurations.module';
    import InvalidityReasons from '../../dataValidation/InvalidityReasons';
    import LoaderIcon from '../../loader/LoaderIcon';
    import axios from 'axios';
    import Images from '../../configuration/Images';
    export default {
        name: 'RopeGuardSelectionModal',
        components: {
            InvalidityReasons,
            LoaderIcon,
            Images,
        },
        computed: {
            sapProfile: {
                get() {
                    return this.$store.state.configurations.sap;
                },
            },
            ropeGuardSelection: {
                get() {
                    return this.$store.state.ropeGuardManual.altRopeGuardSelection;
                }
            },
        },

        created() {
            router.push('/');
        },

        methods: {
            ValueDecimalSeparator(value) {
                if (value != null) {
                    const localDecimal = { value: value, country: this.$store.state.configurations.language, }
                    return this.$get_decimalValueToLocaleString(localDecimal);
                }
                return value;
            },
            closeModal(value) {
                this.$store.dispatch('inputsManual/change_showRopeGuardSelectionModal_storeAction', false);
            },
            rowClick(value, event) {
                if (value != null && value.hasOwnProperty('id') && value.id != null) {                   
                    this.$store.dispatch('ropeGuardManual/change_AltRopeGuard_storeAction', value);
                    this.$store.dispatch('inputsManual/change_showRopeGuardSelectionModal_storeAction', false);
                }
            },
        },
    }
</script>


<style>
    .my_inputCheckboxSelected {
        border: none !important;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

    .my_inputCheckbox2 {
        border: 1px solid #ced2d8;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

        .my_inputCheckbox2 li {
            padding: 3px;
            /*margin-bottom: 3px;*/
        }

    .my_inputCheckbox {
        border: 1px solid #ced2d8;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

        .my_inputCheckbox li {
            display: inline-block;
            padding: 3px;
            /*margin-bottom: 3px;*/
        }

            .my_inputCheckbox li:nth-child(odd) {
                margin-right: 10px;
                width: calc(50% - 10px);
            }

            .my_inputCheckbox li:nth-child(even) {
                margin-left: 10px;
                width: calc(50% - 10px);
            }
</style>
